import { defineTable } from "convex/server";
import { v } from "convex/values";

export const itemTypes = v.union(
  v.literal("product"),
  v.literal("service"),
  v.literal("custom"),
);

export const validatorSaleItem = v.object({
  saleId: v.id("sales"),
  productId: v.optional(v.id("products")),
  name: v.string(),
  description: v.optional(v.string()),
  quantity: v.number(),
  unitPrice: v.number(),
  unit: v.string(),
  taxRate: v.number(),
  subtotal: v.number(),
  taxAmount: v.number(),
  totalAmount: v.number(),

  // f) Exención de impuestos del ítem
  isExempt: v.optional(v.boolean()),
  exemptRate: v.optional(v.number()),
  exemptAmount: v.optional(v.number()),
  // g) Descuentos/bonificaciones
  discountRate: v.optional(v.number()),
  discountAmount: v.optional(v.number()),

  sortOrder: v.optional(v.number()),
  productCode: v.optional(v.string()),
  // Precio de compra para cálculo de margen
  purchasePrice: v.optional(v.number()),
  type: v.optional(itemTypes),
  notes: v.optional(v.string()),
  createdAt: v.optional(v.number()),
  updatedAt: v.optional(v.number()),
});

export const sales_items = defineTable(validatorSaleItem)
  .index("by_sale_id", ["saleId"])
  .index("by_product_code", ["productCode"])
  .index("by_product_id", ["productId"])
  .index("by_type", ["type"])
  .index("by_sort_order", ["saleId", "sortOrder"]);
